// [unleash] 日付ロケール対応: locale パラメータを追加（デフォルトは本家互換の en-GB、サイトロケールを明示的に渡して上書き）
export const getDateString = (isoDate, locale = 'en-GB') => {
    if (!isoDate) {
        return '';
    }
    const event = new Date(isoDate);
    const options = {year: 'numeric', month: 'short', day: 'numeric'};
    return event.toLocaleDateString(locale, options);
};
